import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Certificate() {
  const { t } = useTranslation();
  const location = useLocation();

  // زبان از سگمنت اول URL
  const seg = location.pathname.split("/")[1];
  const lang = seg === "fa" || seg === "en" ? seg : "en";

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    rtl: lang === "fa", // اسلایدر برای فارسی راست‌به‌چپ شود
  };

  // انیمیشن
  useEffect(() => {
    const targets = document.querySelectorAll(".fade-in");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("visible"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  // اسلایدها (فرض: تصاویر در public/assets هستند)
  const slides = [
    { src: "/assets/9001.jpg", alt: t("certificate.images.iso9001") },
    { src: "/assets/14001.jpg", alt: t("certificate.images.iso14001") },
    { src: "/assets/45001.jpg", alt: t("certificate.images.iso45001") },
    { src: "/assets/HSE.jpg", alt: t("certificate.images.hse") },
    { src: "/assets/IMS.jpg", alt: t("certificate.images.ims") },
  ];

  // آیتم‌های لیست به صورت شیء (code/desc)
  const items = t("certificate.items", { returnObjects: true });

  return (
    <>
      <section
        className="col-xs-12 pl-0 pr-0 pt-5 pb-5"
        style={{ background: "#fff" }}
      >
        <div className="certificate">
          <div className="container" dir={lang === "en" ? "ltr" : "rtl"}>
            <div className="col-xs-12 col-md-4">
              <Slider {...settings}>
                {slides.map((s, i) => (
                  <div key={i}>
                    <img
                      src={s.src}
                      className="img-responsive bround-8"
                      alt={s.alt}
                      loading="lazy"
                    />
                  </div>
                ))}
              </Slider>
            </div>

            <div className="col-xs-12 col-md-8 certificate_text">
              <h2 className="text-blue1">{t("certificate.title")}</h2>
              <p className="fade-in from-bottom delay-1">
                {t("certificate.intro", {
                  company: "ARAMIS Industries Intelligent Automation Co",
                })}
              </p>

              <div className="boxone pr-20">
                <h3 className=" mt-5 fs-5 text-blue">
                  {t("certificate.obtainedTitle")}
                </h3>
                <ul>
                  {Array.isArray(items) &&
                    items.map((it, idx) => (
                      <li
                        key={idx}
                        className="fade-in from-right delay-1 visible"
                      >
                        <strong>{it.code}</strong> — {it.desc}
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
